export default __webpack_public_path__ + "4143f83242397dc672cea5dead6e220d.png";